/* eslint-disable max-params */
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Header from "../../shared/marketing-header-with-city";
import Footer from "../../shared/marketing-footer";
import "../../../styles/reset.desktop.css";
import "../../../styles/slick.css";
import "../../../styles/slick-theme.css";
import "../../../styles/slick-reset-desktop.css";
import "@cars24/turbo-web/lib/index.css";
import Error from "../../shared/error";
import ErrorHandler from "../../shared/with-error-handler";
import "intersection-observer";
import LocationPickerPopup from "../location-picker-popup";
import ChatIcon from "../chat-icon";
import ComingSoonCityModal from "../coming-soon-city-modal";

export default function withLayout(WrappedComponent, header = true, footer = true, locationPopup = true) {

    const Layout = (props) => {

        const getLayout = () => {
            let component = (
                <Fragment>
                    {header && <Header {...props} />}
                    <ErrorHandler>
                        <WrappedComponent {...props} />
                    </ErrorHandler>
                    {footer && <Footer {...props} />}
                    <ErrorHandler>
                        {locationPopup && <LocationPickerPopup {...props} />}
                    </ErrorHandler>
                    <ErrorHandler>
                        <ChatIcon {...props} />
                    </ErrorHandler>
                    <ErrorHandler>
                        <ComingSoonCityModal {...props} />
                    </ErrorHandler>
                </Fragment>
            );
            if (props.isSSRError) {
                component = <Error />;
            }
            return component;
        };

        return getLayout();
    };
    const mapStateToProps = ({
        user: { isSSRError }
    }) => {
        return {
            isSSRError
        };
    };

    const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

    return connect(mapStateToProps, mapDispatchToProps)(Layout);
}
